import { render } from "./PageBarraAviso.vue?vue&type=template&id=4a68adfe&scoped=true"
import script from "./PageBarraAviso.vue?vue&type=script&lang=js"
export * from "./PageBarraAviso.vue?vue&type=script&lang=js"

import "./PageBarraAviso.vue?vue&type=style&index=0&id=4a68adfe&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a68adfe"]])

export default __exports__